import { gql } from "@apollo/client";

export const hotspotFragment = gql`
    fragment Hotspot on SparePartHotspot {
        id
        startX
        startY
        endX
        endY
    }
`;

export const sparePartFragment = gql`
    fragment SubGroupDetailSparePart on SparePart {
        id
        quantity
        lineNumber
        isNew
        sortOrder
        hotspots {
            ...Hotspot
        }
        article {
            id
            name(languageCode: $languageCode)
            articleNumber
            assetPath
        }
    }
    ${hotspotFragment}
`;

export const sparePartsQuery = gql`
    query SubGroupDetailSpareParts($modelId: ID!, $componentGroupId: ID!, $languageCode: String) {
        spareParts(filter: { modelId: $modelId, componentGroupId: $componentGroupId }, limit: 100, sort: { field: sortOrder, direction: ASC }) {
            nodes {
                ...SubGroupDetailSparePart
            }
            totalCount
        }
    }
    ${sparePartFragment}
`;
